/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    BadgeOutlined,
    BookmarkOutlined,
    CampaignOutlined,
    GrassOutlined,
    LayersOutlined,
    LocalShippingOutlined,
    MenuBookOutlined,
    ShoppingCartOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Catalogo from "./Secciones/Seccion_Catalogo";
import Seccion_Tipo from "./Secciones/Seccion_Tipo";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Sectores from "./Secciones/Seccion_Sectores";
import Seccion_Reserva from "./Secciones/Seccion_Reserva";
import Seccion_Madurez from "./Secciones/Seccion_Madurez";
import Seccion_Origen from "./Secciones/Seccion_Origen";
import Seccion_Marcas from "./Secciones/Seccion_Marcas";
import telefonos from '../Utilidades/baseDatos.json'
import axios from "axios";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)


    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir
    }


    const {Provider} = contexBarra;


    const envioDatos = async () => {


        let data = telefonos

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/678cd114-361f-48ed-9162-b6439b5fa5d4', //test
            // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/8b56bb1e-d98b-4af4-9b70-54cd5bacc3b8',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log(error);
            });


    }


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            {/*} <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 4}}>
                <Button
                    onClick={() => envioDatos()}
                >Enviar</Button>
            </Grid> */}

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Pedidos',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Catalogo',
        icono: MenuBookOutlined,
        camino: '/Catalogo',
        categoria: 'Pagina',
        Componente: <Seccion_Catalogo/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Pagina',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Marcas',
        icono: BookmarkOutlined,
        camino: '/Marcas',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Marcas/>
    },
    {
        nombre: 'Tipo Agave',
        icono: GrassOutlined,
        camino: '/Tipo',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Tipo/>
    },
    {
        nombre: 'Tipo de Reserva',
        icono: GrassOutlined,
        camino: '/Reserva',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Reserva/>
    },
    {
        nombre: 'Madurez',
        icono: GrassOutlined,
        camino: '/Madurez',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Madurez/>
    },
    {
        nombre: 'Origen Agave',
        icono: GrassOutlined,
        camino: '/Origen',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Origen/>
    },
    {
        nombre: 'Sectores',
        icono: LocalShippingOutlined,
        camino: '/Sectores',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Sectores/>
    },

    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}